export enum THEMES {
  DEFAULT = 'default-theme',
  FR = 'fr-theme',
  FIMM = 'fimm-theme',
  CASANDO = 'casando-theme',
  DHOME = 'dhome-theme',
}
